import { RolesEnum } from "src/app/features/tests/features/constants";
import { Subject } from "../../services/ability/ability.type";

export const SIDEBAR_LINKS = [
    {
      icon: 'dashboard',
      link: '/dashboard',
      title: 'dashboard',
      groups: ['/dashboard'],
      ability: Subject.DashboardPage,
    },
    {
      icon: 'medical_information',
      link: '/physician-dashboard',
      title: 'physician',
      groups: ['/physician-dashboard'],
      ability: Subject.PhysicianDashboardPage,
      showOnlyForRoles: [RolesEnum.SharedPhysician],
    },
    {
      icon: 'groups',
      link: '/patients',
      title: 'patients',
      groups: ['/patients'],
      ability: Subject.PatientsPage,
    },
    {
      icon: 'assignment',
      link: '/tests',
      title: 'tests',
      groups: ['/tests', '/working-area', '/live-tests'],
      ability: Subject.TestsPage,
    },
    {
      icon: 'speaker',
      link: '/devices',
      title: 'devices',
      groups: ['/devices'],
      ability: Subject.DevicesPage,
    },
    {
      icon: 'monitoring',
      link: '/statistics',
      title: 'statistics',
      groups: ['/statistics'],
      ability: Subject.ReportsPage,
      hideForRoles: [RolesEnum.SharedPhysician],
    },
    {
      icon: 'settings',
      link: '/settings',
      title: 'settings',
      groups: ['/settings'],
      ability: Subject.SettingsPage,
    },
  ]
